import moment from "moment";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import API from "../../common/API";
import Settings from "../../common/Settings";

const RecordBiometrical = (props: any) => {
    const { id } = props;
    const [records, setRecords] = useState<any>([]);
    const { t } = useTranslation();

    const bindRecords = async () => {
        try {
            const response = await API.getAction(`employee/getBiometrical?id=${id}`);
            if (response.status === 200) {
                setRecords(response.data.response || []);
            } else {
                console.error("Error fetching employment records:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching employment records:", error);
        }
    }

    useEffect(() => {
        if (id) {
            bindRecords();
        }
    }
        , [id]);
    if (records.length === 0) {
        return null;
    }

    return (<>
        <Card className="my-4" >
            <Card.Header className="display-4">{t("Información Biometrica")}</Card.Header>
            <Card.Body>
                <Row>
                    {records && records.map((item, index) => {
                        return (
                            <Col key={index} className="col-12 col-md-6 col-xl-4">
                                <label>
                                    {t(item.typeName)}
                                    <br />
                                </label>
                                {item?.photo && (
                                    <img
                                        alt=""
                                        className="img-fluid img-thumbnail my-2"
                                        style={{ width: "200px" }}
                                        id="image"
                                        src={`${Settings.BasePath}/files/${item?.photo}`}
                                    />
                                )}
                            </Col>)

                    }
                    )}
                </Row>
            </Card.Body>
        </Card>
    </>
    );
};

export default RecordBiometrical;